/**
 * Progress Page for trAInedup.ai
 * Displays user learning progress and analytics
 */

import React from 'react';
import { Layout } from '../components/common/Layout';
import { ProgressDashboard } from '../components/progress/ProgressDashboard';

/**
 * Progress page component
 */
export const ProgressPage: React.FC = () => {
  return (
    <Layout>
      <div className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ProgressDashboard />
        </div>
      </div>
    </Layout>
  );
};

